import { render, staticRenderFns } from "./Modal-cotiza.vue?vue&type=template&id=6aef654e&scoped=true&lang=pug"
import script from "./Modal-cotiza.vue?vue&type=script&lang=js"
export * from "./Modal-cotiza.vue?vue&type=script&lang=js"
import style0 from "./Modal-cotiza.vue?vue&type=style&index=0&id=6aef654e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aef654e",
  null
  
)

export default component.exports